const apiInitObject = {
    credentials: "include",
    headers: {
        'Content-type': "application/json",
        Accept: 'application/json',
    },
};

export default apiInitObject;